<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>
        <div class="card p-1">
            <div class="row" *ngIf="document">
                <div class="col-6 col-md-4">
                    <label class="font-small-4 font-weight-bold">{{"CATEGORY" | translate}}:</label>
                    <p class="font-medium-1 mb-0" [ngClass.sm]="'mb-1'">{{document.category_name}}</p>
                </div>
                <div class="col-6 col-md-4">
                    <label class="font-small-4 font-weight-bold">{{"DATE" | translate}}:</label>
                    <p class="font-medium-1 mb-0" [ngClass.sm]="'mb-1'">{{_utilService.formatDate(document.send_date, 'DD/MM/YYYY HH:mm')}}</p>
                </div>
                <div class="col-12 col-md-4">
                    <div>
                        <label class="font-small-4 font-weight-bold">{{"REQUIRED_SIGNATURE" | translate}}:</label>
                        <span class="text-success ml-025" [data-feather]="'check'" size="20"
                              *ngIf="document.require_signature == 1"></span>
                        <span class="text-danger ml-025" [data-feather]="'x'" size="20"
                              *ngIf="document.require_signature !== 1 "></span>
                    </div>
                    <div>
                        <label class="font-small-4 font-weight-bold">{{"REQUIRED_ACCEPTION" | translate}}:</label>
                        <span class="text-success ml-025" [data-feather]="'check'" size="20"
                              *ngIf="document.require_acception == 1"></span>
                        <span class="text-danger ml-025" [data-feather]="'x'" size="20"
                              *ngIf="document.require_acception !== 1 "></span>
                    </div>
                </div>
                <div class="col-12" [ngClass.sm]="'mt-1'" *ngIf="!!document.description">
                    <label class="font-small-4 font-weight-bold">{{"DESCRIPTION" | translate}}:</label>
                    <p class="font-medium-1 mb-0" [ngClass.sm]="'mb-1'">{{document.description}}</p>
                </div>
                <div class="col-2">
                    <div class="ml-5" *ngIf="document.send_date > tomorrow && _authenticationService.hasCapability('edit_document')">
                        <button class="btn btn-primary"
                                [routerLink]="'/dashboard/document-edit/'+document.id">{{"EDIT" | translate}}</button>
                    </div>
                </div>
            </div>
        </div>
        <core-card [actions]="[]">
            <div class="card-body" [ngClass.xl]="'d-flex justify-content-between'"
                 *ngIf="document && document.user_data.length > 0">
                <div [ngClass.xl]="'d-flex'">
                    <div class="d-flex">
                        <label for="search"></label>
                        <input [(ngModel)]="searchKeyword" type="text" class="form-control" [ngClass.xl]="'w-fit mr-1'"
                               [ngClass.sm]="'w-100'" id="search" [placeholder]="'SEARCH_EMPLOYEE'|translate"/>
                    </div>
                    <div [ngClass.xl]="'mr-1'" [ngClass.sm]="'my-1'">
                        <select name="category" id="status_signature" [(ngModel)]="filter_status_signature"
                                class="form-control">
                            <option value='4'>{{"STATUS_SIGNATURE" | translate}}</option>
                            <option *ngFor="let status of values_filter_signature"
                                    [value]="status.value">{{status.label | translate}}</option>
                        </select>
                    </div>
                    <div>
                        <select name="category" id="status_acception" [(ngModel)]="filter_status_acception"
                                class="form-control">
                            <option value='4'>{{"STATUS_ACCEPTION" | translate}}</option>
                            <option *ngFor="let status_acception of values_filter_acception"
                                    [value]="status_acception.value">{{status_acception.label | translate}}</option>
                        </select>
                    </div>
                </div>
                <div [ngClass.xl]="'d-flex'" [ngClass.sm]="'d-none'">
                    <label class="d-flex align-items-center ml-5 mr-1 mb-0">{{"SHOW" | translate}}
                        <select class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                    </label>
                </div>
            </div>

            <!--desktop-->
            <div class="card-body p-0" *ngIf="document && _utilService.isDesktop">
                <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="config.headerHeight"
                               [scrollbarH]="config.scrollbarH" [rowHeight]="config.rowHeight" [limit]="tableLimit"
                               [messages]="{emptyMessage: ('NO_DATA_TO_DISPLAY' | translate)}"
                               [footerHeight]="config.footerHeight"
                               [rows]="documentList()">
                    <ngx-datatable-column [name]="'FIRSTNAME_AND_LASTNAME'|translate" prop="firstname" [sortable]="true">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <div class="d-flex align-items-center">
                                <img #image (error)="image.hidden = true" class="rounded-circle mr-1"
                                     src="https://cdn.nepta.dev/avatar/{{row.hash}}.png"
                                     height="32" width="32" alt="datatable-avatar"/>
                                <div class="avatar bg-light-primary mr-1 ml-0" *ngIf="image.hidden">
                                    <div class="avatar-content text-uppercase">{{ row.firstname | initials }}{{ row.lastname | initials }}</div>
                                </div>
                                <div>
                                    <a routerLink="/dashboard/user/profile/{{ row.hash }}"
                                       class="font-medium-1 font-weight-semibold">
                                        {{ row.firstname }} {{ row.firstname != row.lastname ? row.lastname : '' }}
                                    </a>
                                </div>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="{{'STATUS_SIGNATURE' | translate}}" prop="signed" [sortable]="true">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <span class="badge badge-pill badge-light-{{_documentService.document_status_signature_sended[row.status].color}} mr-1"
                                  *ngIf="row.signed == 1 && document.require_signature == 1">{{_documentService.document_status_signature_sended[row.status].label | translate}}
                            </span>
                            <span class="badge badge-pill badge-light-{{_utilService.dateIsInThreeDays(document.end_date) ? 'danger' : 'warning'}} mr-1"
                                  *ngIf="document.end_date && row.signed == 0 && document.require_signature == 1">{{"NOT_SIGNED" | translate}} {{"WITHIN" | translate}} {{_utilService.formatDate(document.end_date)}}
                            </span>
                            <span class="badge badge-pill badge-light-danger mr-1"
                                  *ngIf="!document.end_date && row.signed == 0 && document.require_signature == 1">{{"NOT_SIGNED" | translate}}
                            </span>
                            <span class="badge badge-pill badge-light-secondary mr-1"
                                  *ngIf="document.require_signature == 0">{{"NOT_REQUIRED_SIGNATURE" | translate}}
                            </span>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="{{'STATUS_ACCEPTION' | translate}}" prop="having_read"
                                          [sortable]="true">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <span class="badge badge-pill badge-light-success mr-1"
                                  *ngIf="row.having_read == 1 && document.require_acception == 1">{{"VIEWED" | translate}}
                            </span>
                            <span class="badge badge-pill badge-light-{{_utilService.dateIsInThreeDays(document.end_date) ? 'danger' : 'warning'}} mr-1"
                                  *ngIf="document.end_date && row.having_read == 0 && document.require_acception == 1">{{"NOT_VIEWED" | translate}}
                                {{"WITHIN" | translate}} {{_utilService.formatDate(document.end_date)}}
                            </span>
                            <span class="badge badge-pill badge-light-danger mr-1"
                                  *ngIf="!document.end_date && row.having_read == 0 && document.require_acception == 1">{{"NOT_VIEWED" | translate}}
                            </span>
                            <span class="badge badge-pill badge-light-secondary mr-1"
                                  *ngIf="document.require_acception == 0">{{"NOT_REQUIRED_VIEW" | translate}}
                            </span>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="{{'SEND_STATUS' | translate}}" [sortable]="false">
                        <ng-template ngx-datatable-cell-template let-row="row">
                           <span class="badge badge-pill badge-light-{{_documentService.document_status_send[row.process_status].color}} mr-1">
                               {{_documentService.document_status_send[row.process_status].label | translate}}
                            </span>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="{{'ACTIONS' | translate}}" [sortable]="false">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <button class="btn btn-outline-secondary btn-sm"
                                    [routerLink]="'/dashboard/single-document-file/' + document.id"
                                    [queryParams]="{hash: row.hash}">{{"VIEW" | translate}}</button>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </div>

            <!--mobile-->
            <div class="card-body p-0" *ngIf="document && _utilService.isMobile || _utilService.isTablet">
                <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="config.headerHeight"
                               [scrollbarH]="false" [rowHeight]="180" [limit]="tableLimit"
                               [messages]="{emptyMessage: ('NO_DATA_TO_DISPLAY' | translate)}"
                               [footerHeight]="config.footerHeight"
                               [rows]="documentList()">
                    <ngx-datatable-column [name]="'FIRSTNAME_AND_LASTNAME'|translate" prop="firstname" [sortable]="true">
                        <ng-template ngx-datatable-cell-template let-row="row">
                            <div class="row list-item-mobile">
                                <div class="col-12">
                                    <div class="d-flex align-items-center">
                                        <img #image (error)="image.hidden = true" class="rounded-circle mr-1"
                                             src="https://cdn.nepta.dev/avatar/{{row.hash}}.png"
                                             height="32" width="32" alt="datatable-avatar"/>
                                        <div class="avatar bg-light-primary mr-1 ml-0" *ngIf="image.hidden">
                                            <div class="avatar-content text-uppercase">{{ row.firstname | initials }}{{ row.lastname | initials }}</div>
                                        </div>
                                        <div>
                                            <a routerLink="/dashboard/user/profile/{{ row.hash }}"
                                               class="font-medium-1 font-weight-semibold">
                                                {{ row.firstname }} {{ row.firstname != row.lastname ? row.lastname : '' }}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 my-1">
                                    <span>
                                         <span class="badge badge-pill badge-light-{{_documentService.document_status_signature_sended[row.status].color}} mr-1"
                                               *ngIf="row.signed == 1 && document.require_signature == 1">{{_documentService.document_status_signature_sended[row.status].label | translate}}
                                        </span>
                                        <span class="badge badge-pill badge-light-{{_utilService.dateIsInThreeDays(document.end_date) ? 'danger' : 'warning'}} mr-1"
                                              *ngIf="document.end_date && row.signed == 0 && document.require_signature == 1">{{"NOT_SIGNED" | translate}} {{"WITHIN" | translate}} {{_utilService.formatDate(document.end_date)}}
                                        </span>
                                        <span class="badge badge-pill badge-light-danger mr-1"
                                              *ngIf="!document.end_date && row.signed == 0 && document.require_signature == 1">{{"NOT_SIGNED" | translate}}
                                        </span>
                                        <span class="badge badge-pill badge-light-secondary mr-1"
                                              *ngIf="document.require_signature == 0">{{"NOT_REQUIRED_SIGNATURE" | translate}}
                                        </span>
                                    </span>
                                    <span>
                                        <span class="badge badge-pill badge-light-success mr-1"
                                              *ngIf="row.having_read == 1 && document.require_acception == 1">{{"VIEWED" | translate}}
                                        </span>
                                        <span class="badge badge-pill badge-light-{{_utilService.dateIsInThreeDays(document.end_date) ? 'danger' : 'warning'}} mr-1"
                                              *ngIf="document.end_date && row.having_read == 0 && document.require_acception == 1">{{"NOT_VIEWED" | translate}}
                                            {{"WITHIN" | translate}} {{_utilService.formatDate(document.end_date)}}
                                        </span>
                                        <span class="badge badge-pill badge-light-danger mr-1"
                                              *ngIf="!document.end_date && row.having_read == 0 && document.require_acception == 1">{{"NOT_VIEWED" | translate}}
                                        </span>
                                        <span class="badge badge-pill badge-light-secondary mr-1"
                                              *ngIf="document.require_acception == 0">{{"NOT_REQUIRED_VIEW" | translate}}
                                        </span>
                                    </span>
                                    <span>
                                       <span class="badge badge-pill badge-light-{{_documentService.document_status_send[row.process_status].color}} mr-1">
                                            {{_documentService.document_status_send[row.process_status].label | translate}}
                                        </span>
                                    </span>
                                </div>
                                <div class="col-12">
                                    <button class="btn btn-outline-secondary btn-sm"
                                            [routerLink]="'/dashboard/single-document-file/' + document.id"
                                            [queryParams]="{hash: row.hash}">{{"VIEW" | translate}}
                                    </button>
                                </div>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </div>
        </core-card>
    </div>
</div>